import React, { Suspense } from 'react';
import { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import MwSpinner from './shared/MwSpinner';
import { contractsSettingsSections } from './pages/settingsSections';

/**
 * One section of the contracts settings (contract types...) inside the host app's own settings page,
 * e.g. the "إعدادات العقود" tab of apps-web-absat-v2:
 *   contractsSettingsSections -> the host's side menu items; <ContractsSettingsPanel section={key} /> -> the content.
 * - withToaster: false when the host already renders a react-hot-toast <Toaster />.
 * The `.ct-root` wrapper gives it the module's styles.
 */
const ContractsSettingsPanel = ({ section, withToaster = true }) => {
    const { i18n } = useTranslation('contracts');
    const dir = i18n.dir();
    const active = contractsSettingsSections.find((item) => item.key === section) || contractsSettingsSections[0];
    const { Component } = active;

    return (
        <div className='ct-root ct-settings-panel' dir={dir}>
            {withToaster && (
                <Toaster position='top-center' toastOptions={{ style: { direction: dir, fontFamily: 'Cairo, sans-serif', fontSize: 13 } }} />
            )}
            <Suspense fallback={<MwSpinner hightScreen={false} compact />}>
                <Component />
            </Suspense>
        </div>
    );
};

export default ContractsSettingsPanel;
